import { render, staticRenderFns } from "./MenuService.vue?vue&type=template&id=b0aacad2"
import script from "./MenuService.vue?vue&type=script&lang=ts"
export * from "./MenuService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports